import { LoginPage as KitLoginPage } from 'auth-sso-kit/client';
import { useT } from '../i18n';

export function LoginPage() {
  const { t } = useT();
  return (
    <KitLoginPage
      title="References"
      subtitle={t('login.subtitle')}
      oidcButtonLabel={t('login.oidcButton')}
      emailPlaceholder={t('login.emailPlaceholder')}
    />
  );
}
